export default __webpack_public_path__ + "assets/images/a7b59bbda2bc7a68f9f7e7f2f4062357.png";